import React, { lazy, useEffect, useMemo, useRef, useState, useTransition } from 'react'
import Header from '../components/Header';
import { SaveFab } from '../components/Buttons';
import { TabBar, TabPanel } from '../components/Tabs';
import { Box, Button, Grid, GridSpacing, MenuItem, Snackbar, Tab, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Field, Form, Formik, FormikValues } from 'formik';
import { CheckboxWithLabel, Select, TextField } from 'formik-mui';
import { DatePicker } from 'formik-mui-x-date-pickers';
import {  useLocation, useNavigate, useParams } from 'react-router-dom';
import { axios } from '../api';
import { useSnackbar } from 'notistack';
import { LoadingView } from '../components/Loading';
import CustomSnackbarContent from '../components/CustomSnackbarContent';
import { handleAPIErrors } from '../utils/FormikErrors';
import * as Yup from "yup";
import "../utils/global.css"
import AlertDialog from '../components/AlertDialog';
import { FormDivider } from '../components/Form';
import { CompanyAutocomplete } from '../companies/FormikCompanyAutocomplete';
import Vault from '../components/Vault';
import { AxiosResponse, Method } from 'axios';
import { DueDateDetailView } from './type';
import { useConfig } from '../hooks/useConfig';
import { useGlobalConfig } from '../hooks/useGlobalConfig';
import { useTypeOptions } from '../hooks/useTypeOptions';
import { LoadingComponent } from '../stories/Loaders/ViewLoading.stories';
import { UserAutocomplete } from '../users/user-management/UserAutocomplete';
import { TypeAutocomplete } from '../types/TypeAutoComplete';
import { formtListObject } from './helpers';
import { DueDateAutocomplete } from './DueDateAutocomplete';
import { useCurrentUser } from '../hooks/useCurrentUser';
import {
  calculateDueDateFromLastDoneAndPeriod,
  resolvePeriodLabel,
  sanitizeDueDateForApi,
  sanitizeDueDateForForm,
} from './dueDateDates';
import LinkedRecords from './LinkedRecords';
import Content from '../components/Content';
import { formatAuditTimestamp } from '../utils/formatAuditTimestamp';
import { auditSubtitleText } from "../utils/auditSubtitle";
import UrlsTab from '../urls/UrlsTab';
const DueDateHistoryTab = lazy(() => import('./tabs/DueDateHistoryTab'));

interface DueDateDetailProps {
    originalUrl: any
  canEdit: boolean
}


function a11yProps(index: any) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const DueDateDetail: React.FC<DueDateDetailProps> = (props) => {
  const { originalUrl, canEdit } = props
    let { id } = useParams();
    const navigate = useNavigate();
    const {enqueueSnackbar} = useSnackbar();
    const [title, setTitle] = useState("");
    const [tabValue, setTabValue] = useState(0);
    const formRef = useRef<FormikValues>();
    const [dueDate,setDueDate] = useState<DueDateDetailView>();
    let isRendered = useRef(false);
    const [tabDialogOpen, setTabDialogOpen] = useState(false);
    const [, startTransition] = useTransition();
    const currentUser = useCurrentUser();
    const whiteboardConfig = useConfig("whiteboard");
    const vaultSource =
      (whiteboardConfig?.resource_type as string | undefined) || "whiteboard";

    // "/duedate/create" can match :id with id="create" if the create route
    // is missing — only treat a numeric path segment as an existing record.
    const numericId = useMemo(() => {
      if (id == null || id === "" || id === "create") return null;
      const n = parseInt(id, 10);
      return Number.isFinite(n) && String(n) === id ? n : null;
    }, [id]);

    useEffect(() => {
        isRendered.current = true;
        if (numericId != null) {
          axios
            .get(`/v6/duedate/${numericId}`, { id: `get-duedate-${numericId}` })
            .then((resp: AxiosResponse<DueDateDetailView>) => {
              if (isRendered.current) {
                const duedate: Record<string, unknown> = {};
                for (const value in resp.data) {
                  if(value === 'parent_id'){
                    duedate['parent_obj'] = resp?.data[value]?{id:resp?.data[value] }:null
                  }
                  duedate[value] = resp.data[value] === null ? "" : resp.data[value];
                }
                duedate['due_date'] = sanitizeDueDateForForm(
                  resp.data.required ?? resp.data.due_date ?? ""
                );
                duedate['schedule_date'] = sanitizeDueDateForForm(
                  resp.data.begin_date ?? resp.data.schedule_date ?? ""
                );
                duedate['last_done'] = sanitizeDueDateForForm(resp.data.last_done ?? "");
                duedate['department'] = String(
                  resp.data.department_obj?.id ??
                  resp.data.department ??
                  ""
                );
                duedate['period'] =
                  resp.data.period != null && resp.data.period !== ""
                    ? String(resp.data.period)
                    : "";
                duedate['reference'] = (resp.data as DueDateDetailView).reference ?? "";
               
                setDueDate(duedate as unknown as DueDateDetailView);
              }
              axios.storage.remove(`get-duedate-${numericId}`)
              return null;
            })
            .catch((error) => {
              enqueueSnackbar(`Error fetching DueDate`, {
                variant: "error",
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "center",
                },
              });
              console.error(error);
            });
        }
        else{
            const userId = currentUser?.id ?? currentUser?.uid ?? 0;
            const userName = currentUser?.gecos ?? currentUser?.name ?? "";
            const new_duedate:DueDateDetailView = {
              
                title: "",
                reference: "",
                period: "",
                department: "",
                assigned_to: [],
                status: 1,
                created_by: userId,
                user_obj: userId
                  ? { id: userId, gecos: userName, name: userName } as any
                  : null,
                comment: "",
                endorsments:false,
                last_done: null,
                schedule_date: null,
                due_date: null,
                active:true,
                parent_obj:null
              }
            startTransition(()=>{
                setDueDate(new_duedate)
                setTitle("New Due Date")
            })
        }
    },[numericId,enqueueSnackbar,currentUser])

    useEffect(() => {
      if (!dueDate?.id || numericId == null) return;
      const parentId = dueDate.parent_id || 0;
      if (parentId > 0) {
        setTitle(
          `Due Date Control / ${dueDate.id} ${currentUser?.name} / ${parentId} Child record`
        );
      } else {
        setTitle(`Due Date Control / ${dueDate.id} `);
      }
    }, [dueDate?.id, dueDate?.parent_id, currentUser?.name, numericId]);




    const submitForm = () => {
      if (!canEdit) {
        navigate("..");
        return;
      }

      if (formRef.current) {
        formRef.current.submitForm().then(() => {
          if (
            formRef.current &&
            !formRef.current.isValidating &&
            formRef.current.isValid
          ) {
            navigate("..");
          }
        });
      }
    else{
        navigate(-1)
    }
    };
    
    const saveForm = () => {
      if (!canEdit) {
        return;
      }

      if (formRef.current) {
        formRef.current.submitForm()
      }

    };
    
    const handleClose = () => {
        if (!canEdit) {
          setTabValue(1);
          return;
        }

        if (formRef.current) {
            formRef.current.submitForm().then(() => {
                if (
                  formRef.current &&
                  !formRef.current.isValidating &&
                  formRef.current.isValid
                ) {

                  setTabValue(1);
                }
              });
        }
      };
    
    const handleTabChange = (
        _event: React.SyntheticEvent<{}> | null,
        newValue: unknown) => {
            if (!canEdit) {
              setTabValue(newValue as number);
              return;
            }

            // setTabValue(newValue as number)
          
            if (
                formRef.current &&
                ((formRef.current.dirty && !formRef.current.isSubmitting) ||
                  !formRef.current.initialValues.id)
              ) {
                
                setTabDialogOpen(true);
               
              }
              else{
                setTabValue(newValue as number);
              }
              return;
    }
    return (
        <>
        <Header actions={canEdit ? [<SaveFab onClick2={saveForm} onClick={submitForm} key={1} />] : []}>
                {title}
            </Header>
            <TabBar value={tabValue} onChange={handleTabChange}>
                <Tab disableRipple label="General" {...a11yProps(0)} />
                {(dueDate?.parent_id || 0) === 0 && (
                  <Tab disableRipple label="Linked Records" {...a11yProps(1)} />
                )}
                <Tab
                  disableRipple
                  label="Files"
                  {...a11yProps((dueDate?.parent_id || 0) === 0 ? 2 : 1)}
                />
                <Tab
                  disableRipple
                  label="Links"
                  {...a11yProps((dueDate?.parent_id || 0) === 0 ? 3 : 2)}
                />
                <Tab
                  disableRipple
                  label="History"
                  {...a11yProps((dueDate?.parent_id || 0) === 0 ? 4 : 3)}
                />
            </TabBar>
            <Content data-testid="duedate-content">
                <TabPanel value={tabValue} index={0} data-testid="duedate-form">
                    {
                    dueDate ?<General formRef={formRef} originalUrl={originalUrl} dueDate={dueDate} setDueDate = {setDueDate} canEdit={canEdit} />:<LoadingView/>
                    }
                </TabPanel>
                <TabPanel value={tabValue} index={1} data-testid="duedate-linked-records">
                    {
                    (dueDate?.parent_id || 0) ===  0 && (dueDate  ?<LinkedRecords duedate={dueDate} canEdit={canEdit} />:<LoadingView/>)
                    }
                </TabPanel>
                <TabPanel value={tabValue} index={(dueDate?.parent_id || 0) ===  0 ? 2:1} data-testid="duedate-doc">
                    {
                        dueDate?.id ?
                        <Box className="detail-view-card">
                        <Vault 
                        toolbar={canEdit}
                        autosend
                        readOnly={!canEdit}
                        path={`duedate/${dueDate.id}/`}
                        source={vaultSource}
                        id={dueDate.id}/></Box>
                        :<LoadingView/>
                    }
                </TabPanel>
                <TabPanel
                  value={tabValue}
                  index={(dueDate?.parent_id || 0) === 0 ? 3 : 2}
                  data-testid="duedate-links"
                >
                  {dueDate?.id ? (
                    <UrlsTab
                      source="duedate"
                      sourceId={dueDate.id}
                      canEdit={canEdit}
                    />
                  ) : (
                    <LoadingView />
                  )}
                </TabPanel>
                <TabPanel value={tabValue} index={(dueDate?.parent_id || 0) ===  0 ? 4:3} data-testid="duedate-history">
                    {
                        dueDate?.id ? <DueDateHistoryTab dueDateId={dueDate.id} /> : <LoadingView/>
                    }
                </TabPanel>
            </Content>
            {canEdit ? <AlertDialog
            title="Are you sure ?"
            description="Due Date is not saved"
            open={tabDialogOpen}
            handleClose={() => {
              setTabDialogOpen(false);
            }}
          >
            <Button
              onClick={() => {
                setTabDialogOpen(false);
              }}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                if (formRef.current) {
                  formRef.current.resetForm();
                  setTabDialogOpen(false);
                }
              }}
              color="primary"
            >
              Reset
            </Button>
            <Button
              onClick={() => {
                setTabDialogOpen(false);
                handleClose();
              }}
              color="primary"
              autoFocus
            >
              Save
            </Button>
          </AlertDialog> : null}
        </>
    )
}


export interface GeneralTabProps {
    originalUrl: string;
    formRef?: any;
    dueDate:DueDateDetailView;
    setDueDate:any;
  canEdit:boolean;
}

const General = (props: GeneralTabProps) => {
  const { formRef ,dueDate , setDueDate, canEdit} = props
    const dueDateConfig = useConfig("whiteboard")
    const globalConfig = useGlobalConfig();
    const { enqueueSnackbar } = useSnackbar();
    const location = useLocation();
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down("md"));
    let gridSpacing: GridSpacing = isSmall ? 2 : 6;
  const isReadOnly = !canEdit;
  const dateFormat = globalConfig?.date_format ?? "dd/MM/yyyy";

  const departmentParentId = useMemo(() => {
    const raw =
      dueDateConfig?.department_parent_id;
    if (raw == null || raw === "") return undefined;
    if (typeof raw === "string") {
      const parenMatch = raw.match(/\((\d+)\)\s*$/);
      if (parenMatch) return Number(parenMatch[1]);
      const n = Number(raw);
      return Number.isFinite(n) && n > 0 ? n : undefined;
    }
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? n : undefined;
  }, [dueDateConfig]);

  const periodParentId = useMemo(() => {
    const raw =
      dueDateConfig?.due_date_period;
    // Parent id for types — skip if config is a list/map object
    if (raw == null || raw === "" || typeof raw === "object") return undefined;
    if (typeof raw === "string") {
      const parenMatch = raw.match(/\((\d+)\)\s*$/);
      if (parenMatch) return Number(parenMatch[1]);
      const n = Number(raw);
      return Number.isFinite(n) && n > 0 ? n : undefined;
    }
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? n : undefined;
  }, [dueDateConfig]);

  const periodConfigMap =
    dueDateConfig?.due_date_period &&
    typeof dueDateConfig.due_date_period === "object"
      ? (dueDateConfig.due_date_period as Record<string, string>)
      : null;

  const departmentOptions = useTypeOptions(departmentParentId);
  const periodOptions = useTypeOptions(periodParentId);

  const departmentSelectOptions = useMemo(
    () => (departmentOptions ?? []).filter((o: any) => o.value !== ""),
    [departmentOptions]
  );
  const periodSelectOptions = useMemo(
    () => (periodOptions ?? []).filter((o: any) => o.value !== ""),
    [periodOptions]
  );

    const dueDateSchema = Yup.object().shape({
        title: Yup.string().required("Required"),
        due_date: Yup.mixed()
          .required("Required")
          .test("due-date-required", "Required", (value) => {
            if (value == null || value === "") return false;
            if (
              typeof value === "string" &&
              value.trim().startsWith("0000-00-00")
            ) {
              return false;
            }
            return true;
          }),
      });

  const auditSubtitle = useMemo(() => {
    if (!dueDate?.id) return "";
    const createdBy =
      (dueDate.user_obj as any)?.name ?? dueDate.user_obj?.gecos ?? "";
    const modifiedBy =
      (dueDate.modified_by_user as any)?.name ??
      dueDate.modified_by_user?.gecos ??
      "";
    const dateCreated = dueDate.created
      ? formatAuditTimestamp(dueDate.created, globalConfig?.date_format)
      : "";
    const dateModified = dueDate.modified
      ? formatAuditTimestamp(dueDate.modified, globalConfig?.date_format)
      : "";
    return auditSubtitleText(createdBy, dateCreated, modifiedBy, dateModified);
  }, [dueDate, globalConfig]);

    return (
        <>
            <Formik
                enableReinitialize
                initialValues={dueDate}
                innerRef={formRef}
                validationSchema={dueDateSchema}
                onSubmit={(values, { setSubmitting, setErrors, resetForm }) => {
                  if (!canEdit) {
                    setSubmitting(false);
                    return;
                  }

                  console.log(values,"valuesss")
                  const data = {...values}
                    let method: Method = "post";
                    let url:string = `/v6/duedate`;
                    let msg: string = "created";

                    if (Object.prototype.hasOwnProperty.call(dueDate, "id") && dueDate.id) {
                        method = "put";
                        url = `/v6/duedate/${dueDate.id}`;
                        msg = "updated";
                    }

                    const dueDateData = Object.entries(values).reduce((acc, [key, value]) => {
                      if (key === "user_obj"){
                        console.log("here",data['user_obj'])
                        acc["created_by"] = data['user_obj']?.id || 0
                      }
                      else if (key === "section")
                      {
                        acc['section_id'] = data['section']?.id || 0
                      }
                      else if (key === "department_obj"){
                        // handled via department Select
                      }
                      else if (key === "department"){
                        acc['department'] = value ? Number(value) : 0
                      }
                      else if (key === 'type_obj'){
                        acc['type_id'] = data['type_obj']?.id || 0
                      }
                      else if (key === 'supervisor_obj'){
                        acc['supervisor'] = data['supervisor_obj']?.id || 0
                      } 
                      else if (key === 'assigned_obj'){
                        acc['assigned_to'] = data['assigned_obj']?.id || 0
                      }
                     else  if (key === 'assigned_to'){
                        acc['assigned_to'] = formtListObject(value)
                      }
                      else if(key === 'parent_obj'){

                        acc['parent_id'] = data['parent_obj']?.id || 0
                      }
                      else if (key === 'company_obj'){
                        acc['company_id'] = data['company_obj']?.id || 0
                      }
                      else if (key === 'due_date'){
                        acc['required'] = sanitizeDueDateForApi(value, dateFormat)
                      }
                      else if (key === 'schedule_date'){
                        acc['begin_date'] = sanitizeDueDateForApi(value, dateFormat)
                      }
                      else if (key === 'last_done'){
                        acc['last_done'] = sanitizeDueDateForApi(value, dateFormat)
                      }
                      else if (
                        key === 'modified_by_user' ||
                        key === 'created' ||
                        key === 'modified' ||
                        key === 'required' ||
                        key === 'begin_date' ||
                        key === 'parent_id'
                      ){
                        // skip read-only / aliased fields (parent_id comes from parent_obj)
                      }
                      else{
                        acc[key] = value
                      }
                      return acc;
                    }, {} as DueDateDetailView);

                    if (values.period !== "" && values.period != null) {
                      (dueDateData as any).period = Number(values.period);
                    }

                    axios({
                        url: url,
                        method: method,
                        data: dueDateData
                    }).then((resp: AxiosResponse<DueDateDetailView>)=>{
                        axios.storage.remove(`get-duedate-${dueDate.id}`)
                        resp.data.assigned_to = []
                        const parentId = resp.data?.parent_id || 0
                        resp.data['parent_obj'] =
                          parentId > 0 ? { id: parentId } : null
                        resp.data['parent_id'] = parentId
                        resp.data['due_date'] = sanitizeDueDateForForm(resp.data.required ?? "");
                        resp.data['schedule_date'] = sanitizeDueDateForForm(resp.data.begin_date ?? "");
                        resp.data['last_done'] = sanitizeDueDateForForm(resp.data.last_done ?? "");
                        resp.data['department'] = String(
                          resp.data.department_obj?.id ??
                          resp.data.department ??
                          ""
                        );
                        if (resp.data.period != null && resp.data.period !== "") {
                          (resp.data as any).period = String(resp.data.period);
                        }
                        setDueDate(resp.data)
                        let uri = location.pathname;
                        uri = uri.replace("create",`${resp.data.id}`)
                        enqueueSnackbar(
                            <CustomSnackbarContent
                              message={`Successfully ${msg} DueDate`}
                              uri={uri}
                            />,
                            {
                              variant: "success",
                            }
                          );
                        resetForm();
                        // navigate(-1)
                    }).catch((error)=>{
                        console.debug(error,"error")
                        handleAPIErrors(error, setErrors);
                        setSubmitting(false);
                        enqueueSnackbar(`Error saving DueDate ${error['response']['data']['detail'][0]['loc'][1]}`, {
                            variant: "error",
                        });
                    })
                }}
            >
                {({ values, setFieldValue }) => {
                  const handleCalculateDueDate = () => {
                    const periodLabel = resolvePeriodLabel(
                      values.period,
                      periodSelectOptions as { value: string; label: string }[],
                      periodConfigMap
                    );
                    if (!periodLabel) {
                      enqueueSnackbar("Select a period", {
                        variant: "warning",
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "center",
                        },
                      });
                      return;
                    }
                    const calculated = calculateDueDateFromLastDoneAndPeriod(
                      values.last_done,
                      periodLabel
                    );
                    if (!calculated) {
                      enqueueSnackbar("Enter Last Done and Period to calculate Due Date", {
                        variant: "warning",
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "center",
                        },
                      });
                      return;
                    }
                    setFieldValue("due_date", calculated);
                  };

                  return (
                    <>
                    <Form className="mui-form">
                      {/* Top section — Title / Company / Status (no section-padding; matches QuoteEdit) */}
                      <Grid container spacing={gridSpacing}>
                        <Grid item xs={12} md={6} lg={4}>
                          <Field
                            autoFocus
                            required
                            fullWidth
                            component={TextField}
                            label="Title"
                            name="title"
                            disabled={isReadOnly}
                          />
                          <Field
                            fullWidth
                            component={TextField}
                            label="Reference"
                            name="reference"
                            disabled={isReadOnly}
                          />
                        </Grid>

                        <Grid item xs={12} md={6} lg={4}>
                          <Field
                            required
                            fullWidth
                            component={CompanyAutocomplete}
                            label="Company"
                            name="company_obj"
                            disabled={isReadOnly}
                          />
                          <Field
                            required
                            fullWidth
                            component={UserAutocomplete}
                            label="Created By"
                            name="user_obj"
                            disabled={isReadOnly}
                          />
                        </Grid>

                        <Grid item xs={12} md={6} lg={4}>
                          {dueDateConfig ? (
                            <Field
                              required
                              fullWidth
                              component={Select}
                              formControl={{ fullWidth: true }}
                              label="Status"
                              name="status"
                              disabled={isReadOnly}
                            >
                              {Object.entries(dueDateConfig?.status).map(
                                (entry: [string, unknown]) => (
                                  <MenuItem key={entry[0]} value={entry[0]}>
                                    {dueDateConfig?.status[entry[0]]}
                                  </MenuItem>
                                )
                              )}
                            </Field>
                          ) : (
                            <LoadingComponent />
                          )}
                          <Field
                            fullWidth
                            component={DueDateAutocomplete}
                            label="Due Date Number"
                            name="parent_obj"
                            duedate_id={dueDate?.id || 0}
                            disabled={isReadOnly}
                          />
                        </Grid>
                      </Grid>

                      {/* Details section */}
                      <Grid container spacing={gridSpacing}>
                        <FormDivider className="form-divider">Details</FormDivider>

                        <Grid item className="section-padding" xs={12} md={6} lg={4}>
                          {dueDateConfig?.type ? (
                            <Field
                              required
                              label="Type"
                              name="type_obj"
                              component={TypeAutocomplete}
                              fullWidth
                              parent_id={dueDateConfig?.type}
                              disabled={isReadOnly}
                            />
                          ) : (
                            <Snackbar />
                          )}
                          {dueDateConfig?.sections_id ? (
                            <Field
                              required
                              name="section"
                              label="Section"
                              component={TypeAutocomplete}
                              fullWidth
                              parent_id={dueDateConfig?.sections_id}
                              disabled={isReadOnly}
                            />
                          ) : (
                            <Snackbar />
                          )}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 2,
                            }}
                          >
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Field
                                required
                                fullWidth
                                component={DatePicker}
                                label="Schedule Date"
                                name="schedule_date"
                                inputFormat={dateFormat}
                                disabled={isReadOnly}
                              />
                            </Box>
                            <Field
                              component={CheckboxWithLabel}
                              name="endorsments"
                              type="checkbox"
                              color="primary"
                              disabled={isReadOnly}
                              Label={{
                                label: "Endorsements",
                                sx: { px: 1, whiteSpace: "nowrap" },
                              }}
                            />
                          </Box>
                        </Grid>

                        <Grid item className="section-padding" xs={12} md={6} lg={4}>
                          <Field
                            component={Select}
                            formControl={{ fullWidth: true }}
                            label="Department"
                            name="department"
                            disabled={isReadOnly || !departmentParentId}
                          >
                            {departmentSelectOptions.length === 0 ? (
                              <MenuItem value="">
                                {dueDateConfig
                                  ? "No departments (check whiteboard_department_parent_id)"
                                  : "Loading…"}
                              </MenuItem>
                            ) : (
                              departmentSelectOptions.map((option: any) => (
                                <MenuItem
                                  key={option.value}
                                  value={option.value}
                                >
                                  {option.label}
                                </MenuItem>
                              ))
                            )}
                          </Field>
                          {dueDateConfig?.assign_multi_user !== "yes" ? (
                            <Field
                              required
                              fullWidth
                              component={UserAutocomplete}
                              label="Assigned To"
                              name="assigned_obj"
                              disabled={isReadOnly}
                            />
                          ) : (
                            <Field
                              component={UserAutocomplete}
                              label="Assigned To"
                              name="assigned_to"
                              multiple
                              disabled={isReadOnly}
                            />
                          )}
                          <Field
                            required
                            fullWidth
                            component={UserAutocomplete}
                            label="Supervisor"
                            name="supervisor_obj"
                            disabled={isReadOnly}
                          />
                        </Grid>

                        <Grid item className="section-padding" xs={12} md={6} lg={4}>
                          <Field
                            required
                            fullWidth
                            component={DatePicker}
                            label="Last Done"
                            name="last_done"
                            inputFormat={dateFormat}
                            disabled={isReadOnly}
                          />
                          {periodParentId ? (
                            <Field
                              required
                              component={Select}
                              formControl={{ fullWidth: true }}
                              label="Period"
                              name="period"
                              disabled={isReadOnly}
                            >
                              {periodSelectOptions.map((option: any) => (
                                <MenuItem key={option.value} value={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Field>
                          ) : periodConfigMap ? (
                            <Field
                              required
                              component={Select}
                              formControl={{ fullWidth: true }}
                              label="Period"
                              name="period"
                              disabled={isReadOnly}
                            >
                              {Object.entries(periodConfigMap).map(
                                ([key, label]) => (
                                  <MenuItem key={key} value={key}>
                                    {label}
                                  </MenuItem>
                                )
                              )}
                            </Field>
                          ) : (
                            <Field
                              required
                              fullWidth
                              component={TextField}
                              label="Period"
                              name="period"
                              disabled={isReadOnly}
                            />
                          )}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Field
                                required
                                fullWidth
                                component={DatePicker}
                                label="Due Date"
                                name="due_date"
                                inputFormat={dateFormat}
                                disabled={isReadOnly}
                              />
                            </Box>
                            {!isReadOnly ? (
                              <Button
                                type="button"
                                variant="outlined"
                                onClick={handleCalculateDueDate}
                                sx={{ whiteSpace: "nowrap", flexShrink: 0 }}
                              >
                                Calculate
                              </Button>
                            ) : null}
                          </Box>
                        </Grid>

                        <Grid item className="section-padding" xs={12}>
                          <Field
                            required
                            fullWidth
                            multiline
                            rows={6}
                            maxRows={12}
                            component={TextField}
                            label="Comment"
                            name="comment"
                            disabled={isReadOnly}
                          />
                        </Grid>
                      </Grid>
                    </Form>
                      {auditSubtitle ? (
                        <Box>
                          <Typography
                            fontSize="small"
                            sx={{ textAlign: "right", marginTop: "20px" }}
                          >
                            {auditSubtitle}
                          </Typography>
                        </Box>
                      ) : null}
                    </>
                  );
                }}

            </Formik>
        </>
    )
}

export default DueDateDetail
